import { render, staticRenderFns } from "./IconGatepass.vue?vue&type=template&id=bfcde70a"
import script from "./IconGatepass.vue?vue&type=script&lang=js"
export * from "./IconGatepass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports